import Controller from '@ember/controller';

export default class WithPartController extends Controller {
  queryParams = ['doc'];
  doc = null;
}
